export const INTERNAL_BLANK_DATA = {
    description: '',
    groups: [],
    accounts: []
}